export default __webpack_public_path__ + "static/media/carfixer.29919b37.png";